export default __webpack_public_path__ + "static/media/capelo-grande.a25da4b8.svg";